(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-block')) {
    customElements.define('accordion-block', class ScrollToSection extends HTMLElement {
      constructor() {
        super();

        this.isOpen = this.getAttribute('data-open') === 'true';
        this.summary = this.querySelector('.accordion-block__summary');
        this.summaryButton = this.summary.querySelector('button');
      }

      connectedCallback() {

        this.summary.addEventListener('click', () => {
          this.isOpen = this.getAttribute('data-open') === 'true';
          if (this.isOpen) {
            this.close();
          } else {
            this.open();
          }
        });

        // open on enter click if button is in focus
        this.summaryButton.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.isOpen = this.getAttribute('data-open') === 'true';
            if (this.isOpen) {
              this.close();
            } else {
              this.open();
            }
          }
        });
      }

      open() {
        this.setAttribute('data-open', 'true');
        this.summaryButton.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.setAttribute('data-open', 'false');
        this.summaryButton.setAttribute('aria-expanded', 'false');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swiper-carousel')) {
    customElements.define('swiper-carousel', class SwiperCarousel extends HTMLElement {

      constructor() {
        super();
        this.swiperEl = this.querySelector(`#${this.id} > .swiper`);
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        this.setupSwiperParams();
        this.swiperInstance = new Swiper(this.swiperEl, this.swiperParams);
        this.handleNestedCarousels();
      }

      setupSwiperParams() {
        const element = this;

        this.swiperParams = {
          allowTouchMove: this.getAttribute("allow-touch-move-mobile") === "true",
          observer: true,
          resizeObserver: true,
          slidesOffsetBefore: this.getAttribute("slides-offset-before-mobile") ? Number(this.getAttribute("slides-offset-before-mobile")) : 0,
          slidesOffsetAfter: this.getAttribute("slides-offset-after-mobile") ? Number(this.getAttribute("slides-offset-after-mobile")) : 0,
          slidesPerView: this.getAttribute("slides-per-view-auto-mobile") === "true" ? "auto" : Number(this.getAttribute("slides-per-view-mobile")),
          spaceBetween: Number(this.getAttribute("space-between-mobile")),
          loop: this.getAttribute("loop-slides-mobile") === "true",

          ...(this.getAttribute("show-navigation-buttons-mobile") === "true" && {
            navigation: {
              nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
              prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
            },
          }),

          ...(this.getAttribute("show-scrollbar-mobile") === "true" && {
            scrollbar: {
              el: `#${this.id} > .swiper-scrollbar`,
              draggable: true,
              snapOnRelease: true
            },
          }),

          breakpoints: {
            750: {
              allowTouchMove: this.getAttribute("allow-touch-move") === "true",
              slidesOffsetBefore: this.getAttribute("slides-offset-before") ? Number(this.getAttribute("slides-offset-before")) : 0,
              slidesOffsetAfter: this.getAttribute("slides-offset-after") ? Number(this.getAttribute("slides-offset-after")) : 0,
              slidesPerView: this.getAttribute("slides-per-view-auto-tablet") === "true" ? "auto" : Number(this.getAttribute("slides-per-view-tablet")),
              spaceBetween: Number(this.getAttribute("space-between-tablet")),
              loop: this.getAttribute("loop-slides") === "true",

              ...(this.getAttribute("show-navigation-buttons") === "true" && {
                navigation: {
                  nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
                  prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
                },
              }),

              ...(this.getAttribute("show-scrollbar") === "true" && {
                scrollbar: {
                  el: `#${this.id} > .swiper-scrollbar`,
                  draggable: true,
                  snapOnRelease: true
                },
              }),
            },
            1200: {
              allowTouchMove: this.getAttribute("allow-touch-move") === "true",
              slidesOffsetBefore: this.getAttribute("slides-offset-before") ? Number(this.getAttribute("slides-offset-before")) : 0,
              slidesOffsetAfter: this.getAttribute("slides-offset-after") ? Number(this.getAttribute("slides-offset-after")) : 0,
              slidesPerView: this.getAttribute("slides-per-view-auto") === "true" ? "auto" : Number(this.getAttribute("slides-per-view")),
              spaceBetween: Number(this.getAttribute("space-between")),
              loop: this.getAttribute("loop-slides") === "true",

              ...(this.getAttribute("show-navigation-buttons") === "true" && {
                navigation: {
                  nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
                  prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
                },
              }),

              ...(this.getAttribute("show-scrollbar") === "true" && {
                scrollbar: {
                  el: `#${this.id} > .swiper-scrollbar`,
                  draggable: true,
                  snapOnRelease: true
                },
              }),
            },
          },
          on: {
            init(swiper) {
              element.updateNavigationState(swiper);
            },
            resize(swiper) {
              element.updateNavigationState(swiper);
            },
            update(swiper) {
              element.updateNavigationState(swiper);
            }
          }
        };
      }

      updateNavigationState(swiper) {
        const isAuto = swiper.params.slidesPerView === 'auto';

        if (isAuto) {
          let totalSlidesWidth = 0;
          swiper.slides.forEach(slide => {
            totalSlidesWidth += slide.offsetWidth + swiper.params.spaceBetween;
          });

          const fitsInContainer =
            totalSlidesWidth - swiper.params.spaceBetween <=
            swiper.width - swiper.params.slidesOffsetBefore;

          if (fitsInContainer) {
            this.disableNavigation(swiper);
            swiper.disable();
          } else {
            this.enableNavigation(swiper);
            swiper.enable();
          }

        } else {
          const numberOfSlides = swiper.slides.length;

          if (numberOfSlides <= swiper.params.slidesPerView) {
            this.disableNavigation(swiper);
            swiper.disable();
          } else {
            this.enableNavigation(swiper);
            swiper.enable();
          }
        }

        // Disable prev button on first slide
        if (swiper.navigation?.prevEl) {
          if (swiper.activeIndex === 0) {
            swiper.navigation.prevEl.classList.add('swiper-button-disabled');
          } else {
            swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
          }
        }
      }

      disableNavigation(swiper) {
        if (swiper.navigation?.nextEl && swiper.navigation?.prevEl) {
          swiper.navigation.nextEl.classList.add('swiper-button-disabled');
          swiper.navigation.prevEl.classList.add('swiper-button-disabled');
        }
      }

      enableNavigation(swiper) {
        if (swiper.navigation?.nextEl && swiper.navigation?.prevEl) {
          swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
          swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
        }
      }

      handleNestedCarousels() {
        const nestedCarousels = this.querySelectorAll('swiper-carousel');
        if (nestedCarousels.length === 0) return;

        nestedCarousels.forEach((carousel) => {
          carousel.addEventListener('mouseenter', () => {
            this.swiperInstance.allowTouchMove = false;
          });
          carousel.addEventListener('mouseleave', () => {
            this.swiperInstance.allowTouchMove = true;
          });
          carousel.addEventListener('touchstart', () => {
            this.swiperInstance.allowTouchMove = false;
          });
          carousel.addEventListener('touchend', () => {
            this.swiperInstance.allowTouchMove = true;
          });
        });
      }

    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-to-section"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-to-section')) {
    customElements.define('scroll-to-section', class ScrollToSection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        this.scrollOffset = parseInt(this.dataset.scrollOffset) || 0;
        this.sectionId = this.dataset.sectionId;

        this.addEventListener('click', () => {
          const targetElement = document.getElementById(this.sectionId);
          const elementPosition = targetElement ? targetElement.getBoundingClientRect().top : 0;
          if (targetElement) {
            let offset = this.scrollOffset;
            if (elementPosition < 0) {
              const headerHeightValue = parseInt(this.headerHeight) || 0;
              offset -= headerHeightValue;
            }

            const offsetPosition = elementPosition + window.pageYOffset + offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swiper-slider')) {
    customElements.define('swiper-slider', class SwiperSlider extends HTMLElement {
      constructor() {
        super();

        this.swiperEl = this.querySelector(`#${this.id} > .swiper`);
      }

      connectedCallback() {
        this.initSwiper();
        console.log('initialized swiper slider');
        console.log('swiper',this.getAttribute("enable-autoplay"));
      }

      initSwiper() {
        this.setupSwiperParams();
        console.log('swiper params',this.swiperParams);
        this.swiperInstance = new Swiper(this.swiperEl, this.swiperParams);
      }

      setupSwiperParams() {
        this.swiperParams = {
          allowTouchMove: true,
          speed: this.getAttribute("animation-speed") ? parseInt(this.getAttribute("animation-speed")) : 1000,
          observer: true,
          resizeObserver: true,
          // Mobile defaults
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          ...(this.getAttribute("enable-autoplay") === "true" && {
            autoplay: {
              delay: this.getAttribute("autoplay-delay") ? parseInt(this.getAttribute("autoplay-delay")) : 5000,
              disableOnInteraction: this.getAttribute("disable-on-interaction") === "true" ? true : false,
            },
          }),
          ...(this.getAttribute("show-navigation-mobile") === "true" && {
            navigation: {
              nextEl: `#${this.id} > .swiper > .slider-navigation-container > .slider-button-next`,
              prevEl: `#${this.id} > .swiper > .slider-navigation-container > .slider-button-prev`,
            },
          }),
          ...(this.getAttribute("show-navigation-mobile") === "true" && {
            pagination: {
              el: `#${this.id} > .swiper > .slider-navigation-container > .swiper-pagination`,
              clickable: true,
            },
          }),

          // Desktop breakpoint
          breakpoints: {
            750: {
              observer: true,
              speed: this.getAttribute("animation-speed") ? parseInt(this.getAttribute("animation-speed")) : 1000,
              resizeObserver: true,
              allowTouchMove: true,
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              ...(this.getAttribute("show-navigation") === "true" && {
                navigation: {
                  nextEl: `#${this.id} > .swiper > .slider-navigation-container > .slider-button-next`,
                  prevEl: `#${this.id} > .swiper > .slider-navigation-container > .slider-button-prev`,
                },
              }),
              ...(this.getAttribute("show-navigation") === "true" && {
                pagination: {
                  el: `#${this.id} > .swiper > .slider-navigation-container > .swiper-pagination`,
                  clickable: true,
                },
              }),
            },
          },
          on: {
            init() {
              // hide navigation if there is only one slide or 0
              const numberOfSlides = this.slides.length;
              if (numberOfSlides <= 1) {
                if(this.navigation.nextEl && this.navigation.prevEl) {
                  this.navigation.nextEl.style.display = 'none';
                  this.navigation.prevEl.style.display = 'none';
                }
              } else {
                if(this.navigation.nextEl && this.navigation.prevEl) {
                  this.navigation.nextEl.style.display = '';
                  this.navigation.prevEl.style.display = '';
                }
              }
            },
            update() {
              // hide navigation if there is only one slide or 0
              const numberOfSlides = this.slides?.length;
              if (numberOfSlides <= 1) {
                if(this.navigation?.nextEl && this.navigation?.prevEl) {
                  this.navigation.nextEl.style.display = 'none';
                  this.navigation.prevEl.style.display = 'none';
                }
              } else {
                if(this.navigation?.nextEl && this.navigation?.prevEl) {
                  this.navigation.nextEl.style.display = '';
                  this.navigation.prevEl.style.display = '';
                }
              }
            }
          }
        };
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-wrapper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-wrapper')) {
    customElements.define('sticky-wrapper', class StickyWrapper extends HTMLElement {
      constructor() {
        super();
        this._onScroll = this._onScroll.bind(this);
        this.initialOffsetTop = 0;
        this.isSticky = false;
        this.stickyParent = this.parentElement;
      }

      connectedCallback() {
        this.initialOffsetTop = this.getBoundingClientRect().top + window.scrollY;
        window.addEventListener('scroll', this._onScroll);
        this._fixParentHeight();

        window.addEventListener(
          'resize',
          debounce(() => {
            // remove sticky temporarily to measure true natural position
            this.classList.remove('is-sticky');
            this.isSticky = false;

            requestAnimationFrame(() => {
              this.initialOffsetTop = this.getBoundingClientRect().top + window.scrollY;
              this._fixParentHeight();
            });
          }, 150)
        );
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
      }

      _onScroll() {
        const scrollY = window.scrollY;

        if (!this.isSticky && scrollY >= this.initialOffsetTop) {
          this.isSticky = true;
          this.classList.add('is-sticky');
        } else if (this.isSticky && scrollY < this.initialOffsetTop) {
          this.isSticky = false;
          this.classList.remove('is-sticky');
        }
      }

      _fixParentHeight() {
        const wrapperHeight = this.offsetHeight;
        this.stickyParent.style.minHeight = `${wrapperHeight}px`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabbed-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabbed-carousel')) {
    customElements.define('tabbed-carousel', class TabsCarousel extends HTMLElement {
      constructor() {
        super();
        this.tabsElements = this.querySelectorAll('.tabbed__carousel--tabs .tabbed__carousel--tab');
        this.carouselElement = this.querySelector('swiper-carousel .swiper');
      }

      connectedCallback() {
        if (!this.carouselElement || this.tabsElements.length === 0) return;
        this.tabsElements.forEach(tab => {
          tab.addEventListener('click', this.handleTabsClick.bind(this));
        });
        this.setInitialProducts();
      }

      handleTabsClick(event) {
        const clickedTab = event.currentTarget;
        const clickedTabButton = clickedTab.querySelector('button');
        clickedTabButton.classList.add('active');

        this.tabsElements.forEach(tab => {
          if (tab !== clickedTab) {
            const tabButton = tab.querySelector('button');
            tabButton.classList.remove('active');
          }
        });

        const productsTemplate = clickedTab.querySelector('template').content.cloneNode(true);
        const products = productsTemplate.querySelectorAll('.swiper-slide');

        this.carouselElement.swiper.slideTo(0, 0);
        this.carouselElement.swiper.removeAllSlides();
        this.carouselElement.swiper.appendSlide(products);
        this.carouselElement.swiper.update();
      }

      setInitialProducts() {
        let activeTab = this.querySelector('.tabbed__carousel--tabs .tabbed__carousel--tab button.active');
        if(!activeTab) {
          // If no active tab, default to the first tab
          activeTab = this.tabsElements[0].querySelector('button');
          activeTab.classList.add('active');
        }
        if (activeTab) {
          const productsTemplate = activeTab.closest('.tabbed__carousel--tab').querySelector('template').content.cloneNode(true);
          const products = productsTemplate.querySelectorAll('.swiper-slide');
          this.carouselElement.swiper.removeAllSlides();
          this.carouselElement.swiper.appendSlide(products);
          this.carouselElement.swiper.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
